module.exports = __webpack_public_path__ + "img/appointment-screen-device-iphone@3x.28fb1604.png";